import { Helmet } from "react-helmet-async";

export default function RESTPilotSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <Helmet>
        <title>Support - RESTPilot | Cosmovex</title>
        <meta
          name="description"
          content="Support page for RESTPilot, the Cosmovex mobile REST API testing app."
        />
        <link
          rel="canonical"
          href="https://cosmovexapps.com/restpilot/support"
        />
      </Helmet>

      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - RESTPilot
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, common answers, and contact details for RESTPilot users.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <p>
            <strong>RESTPilot</strong> is a mobile-first REST API testing app for
            quick endpoint checks, saved requests, reusable environments, response
            inspection, and API monitoring.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I test an endpoint quickly?
              </h3>
              <p className="mt-1">
                Open the API tab, enter a URL, choose a method like GET or POST,
                and tap Send. RESTPilot will show the response status, body, and
                headers.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I save a request for later?
              </h3>
              <p className="mt-1">
                After preparing a request, tap Save in the top action bar. Saved
                requests appear in the Library tab where you can edit, duplicate,
                pin, or enable Auto Check.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do environments work?
              </h3>
              <p className="mt-1">
                Environments let you reuse base URLs, auth values, headers, and
                variables. Create or edit them from the API screen or the
                Automation tab and switch between them as needed.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                What is Auto Check?
              </h3>
              <p className="mt-1">
                Auto Check helps monitor saved requests over time. You can enable
                it from a saved request and review alerts or issue history in the
                Automation tab.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why does the app show ads?
              </h3>
              <p className="mt-1">
                Some supported versions of RESTPilot may show ads to help support
                development. Ad visibility can vary by platform and release
                configuration.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            For help, bug reports, or privacy-related questions, email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We usually respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            If something is not working as expected, include these details in your
            email:
          </p>
          <ul className="list-disc space-y-2 pl-6">
            <li>Your device model and OS version</li>
            <li>Your app version</li>
            <li>What you were trying to do</li>
            <li>The error or unexpected result</li>
            <li>Steps to reproduce the issue, if known</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">Important Links</h2>
          <ul className="list-disc space-y-2 pl-6">
            <li>
              Privacy Policy:{" "}
              <a
                href="https://cosmovexapps.com/restpilot/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/restpilot/privacy-policy
              </a>
            </li>
            <li>
              Support URL:{" "}
              <a
                href="https://cosmovexapps.com/restpilot/support"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/restpilot/support
              </a>
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc space-y-2 pl-6">
            <li>
              <strong>App Name:</strong> RESTPilot
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact Email:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
